module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_1.f35168bd506fd61c82c57d7db6e086f1.png";